/**
 * Mudanças de um evento ATUALIZACAO da timeline (CRM-29), em linhas legíveis.
 *
 * O backend grava `dados.mudancas = {campo: {antes, depois}}` com o valor
 * cru (Decimal como "80000.00", data como "1990-05-20", tags em lista,
 * vazio como "" ou null). Aqui vira "Rótulo: antes → depois" com dinheiro e
 * data no formato da tela (ADR-0059), para o gestor ver o que mudou sem
 * abrir a auditoria.
 */
import { formatarDataLocal, formatarReaisBR } from "../../../utils/dinheiro";
import { ORIGEM_LEAD_LABEL } from "../../../services/crm";

export const VAZIO = "—";

const ROTULOS = {
  titulo: "Descrição",
  empresa: "Empresa",
  cargo: "Cargo",
  contato_nome: "Nome",
  contato_sobrenome: "Apelido",
  contato_telefone: "Telefone",
  contato_email: "E-mail",
  telefone_secundario: "Telefone 2",
  email_secundario: "E-mail 2",
  instagram: "Instagram",
  site: "Site",
  data_nascimento: "Nascimento",
  descricao_bio: "Bio",
  observacoes: "Observações",
  temperatura: "Temperatura",
  status: "Status",
  origem: "Origem",
  origem_outro: "Origem (outro)",
  valor_estimado: "Valor estimado",
  tags: "Tags",
  proxima_acao: "Próxima ação",
  data_proxima_acao: "Data da próxima ação",
  documento: "CPF/CNPJ",
  enderecos: "Endereços",
};

const CAMPOS_DINHEIRO = new Set(["valor_estimado"]);
const CAMPOS_DATA = new Set(["data_nascimento", "data_proxima_acao"]);

export function rotuloDoCampo(campo) {
  return ROTULOS[campo] || campo;
}

/** Valor cru do evento -> texto de tela. */
export function formatarValorDaMudanca(campo, valor) {
  if (valor == null || valor === "") return VAZIO;
  if (Array.isArray(valor)) return valor.length ? valor.join(", ") : VAZIO;
  if (CAMPOS_DINHEIRO.has(campo)) return formatarReaisBR(valor) || VAZIO;
  if (CAMPOS_DATA.has(campo)) return formatarDataLocal(valor);
  if (campo === "origem") return ORIGEM_LEAD_LABEL[valor] || String(valor);
  if (typeof valor === "boolean") return valor ? "Sim" : "Não";
  return String(valor);
}

/**
 * `[{campo, rotulo, antes, depois}]` a partir de `item.dados` da timeline.
 * Sem `mudancas` (evento antigo, atendimento, compromisso) devolve [].
 */
export function linhasDeMudancas(dados) {
  const mudancas = dados && typeof dados === "object" ? dados.mudancas : null;
  if (!mudancas || typeof mudancas !== "object") return [];
  return Object.entries(mudancas).map(([campo, par]) => ({
    campo,
    rotulo: rotuloDoCampo(campo),
    antes: formatarValorDaMudanca(campo, par?.antes),
    depois: formatarValorDaMudanca(campo, par?.depois),
  }));
}
